import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'

/**
 * Component to display the key value
 * @param {string|number} value - The value to display
 */
const WidgetDisplay = ({ value, t_ }) => {
  const displayValue = value !== null && value !== undefined ? String(value) : '-'

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%'
      }}
      title={t_ ? t_('Current Value') : 'Current Value'}
      aria-label={`${t_ ? t_('Value') : 'Value'}: ${displayValue}`}
    >
      <Typography
        variant='h4'
        component='div'
        align='center'
        sx={{
          fontWeight: 'bold',
          wordBreak: 'break-word',
          // Responsive font size using theme breakpoints if possible,
          // but sx allows array for breakpoints: [xs, sm, md, lg, xl]
          fontSize: { xs: '0.5rem', sm: '0.75rem', md: '1rem' }
        }}
      >
        {displayValue}
      </Typography>
    </Box>
  )
}

WidgetDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  t_: PropTypes.func
}

export default WidgetDisplay
